import { Controller } from "@hotwired/stimulus";
console.log("ShowSubmitWhenChangedController loaded");

export default class extends Controller {
  connect() {
    this.submitButton = this.element.querySelector(
      'button[type="submit"], input[type="submit"]'
    );

    // Get values from visible fields only (i.e. not inpyt[type="hidden"])
    this.visibleFieldsNames = new Set();
    this.element
      .querySelectorAll(
        'input:not([type="hidden"]):not([type="submit"]):not([type="button"]), select, textarea'
      )
      .forEach((el) => this.visibleFieldsNames.add(el.name));

    // Store the original form values in a Map for easy comparison later
    this.originalFormValues = new FormData(this.element).entries();
    this.originalFormValues = new Map(
      [...this.originalFormValues].filter(([key, value]) => {
        return this.visibleFieldsNames.has(key);
      })
    );

    this.element.addEventListener("input", this.updateVisibility.bind(this));
  }

  updateVisibility() {
    // If the form values have changed compared to the original values, show the submit button
    const currentFormValues = new FormData(this.element);
    const hasChanged = [...this.originalFormValues.entries()].some(
      ([key, value]) => {
        return currentFormValues.get(key) !== value;
      }
    );

    if (hasChanged) {
      this.showSubmitButton();
    } else {
      this.hideSubmitButton();
    }
  }

  hideSubmitButton() {
    if (!this.submitButton) return;
    this.submitButton.classList.add("invisible");
  }

  showSubmitButton() {
    if (!this.submitButton) return;
    this.submitButton.classList.remove("invisible");
  }
  disconnect() {
    this.element.removeEventListener("input", this.updateVisibility.bind(this));
  }
}
